<template>
  <!-- .ne near-ex -->
  <div class="ne" v-if="addr&&list.length">
    <div class="ne-title">
      <span class="txt1">
        您附近的展商
        <span class="txt2">{{addr}}</span>
      </span>
      <span class="txt3" @click="more">查看更多</span>
    </div>
    <div class="ne-content" >
      <div v-if="list.length">
         <div class="zs" v-for="(item,index) in list" :key="index">
          <div class="zs-row s-left">
            <div class="zs-row-box-top"  @click="LinkExInvitation({companyId:item.compId,exhibitorId:item.id,exhibitionId:item.exhibitionId})">
              <div class="zs-item">
                <div class="zs-logo">
                  <img :class="{square_logo:configLogoIsSquare}" v-if="item.company.logo" :src="item.company.logo" v-load="'oPic'" />
                  <img :class="{square_logo:configLogoIsSquare}" v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" :src="exhibitionInfo.exhibition.logo" v-load="'oPic'"/>
                  <img :class="{square_logo:configLogoIsSquare}" v-else src="@/assets/img/empty.png" />
                </div>

                <!-- 公司信息 -->
                <div class="zs-test">
                  <div class="zs-test-title">
                    <p>{{item.company.name}}</p>
                    <div class="is_live" v-if="item.isLiving">
                      <span></span>
                      直播中
                    </div>
                    <div class="is_live is_hot" v-if="item.isPopularize">
                      <i class="icon iconfont icon-huo"></i>
                      热榜
                    </div>
                  </div>
                  
                  <div class="zs-test-rank" v-if="item.continuouNumber">
                    <div class="type">
                      <div class="img">
                        <img src="@/assets/img/icon/icon-gold.png"  v-if="item.continuouNumber  > 7">
                        <img src="@/assets/img/icon/icon-copper.png"  v-else-if="item.continuouNumber  < 5 ">
                        <img src="@/assets/img/icon/icon-silver.png"  v-else>
                      </div>
                      <span>连续{{item.continuouNumber}}年参展</span>
                    </div>
                  </div>


                  <!-- 公司下的小标签><-->
                  <div class="zs-test-booth">
                    <div class="zs-tag zs-booth"  v-if="item.boothInfo">
                        <i class="iconfont icon-dizhi"></i><p>{{item.boothInfo}}</p>
                    </div>
                    <div class="zs-tag zs-type" v-if="item.category">
                      <i class="iconfont icon-biaoqian1"></i><p>{{item.category}}</p>
                    </div>
                  </div>

                  <!-- 数据 -->
                  <div class="zs-test-count">
                    <p>
                      共发布: 
                      <span><i>{{item.proCount}}</i>展品</span> 
                      <span><i>{{item.activityCount}}</i>活动</span> 
                      <span><i>{{item.liveCount}}</i>直播</span>
                    </p>
                  </div>

                  <div class="zs-item-bottom">
                    <swiperCard :products="item.products" v-if="item.products.length"></swiperCard>
                    <p class="zs-item-news" v-if="item.newestEvaluates[0]"><span>最新评价：</span>{{item.newestEvaluates[0].content}}</p>
                    <div class="zs-item-zan" v-if="item.likes && item.likes.length">
                      <template v-for="(item,index) in item.likes">
                        <img :src="JSON.parse(item.userInfo).avatarUrl"  v-if="JSON.parse(item.userInfo).avatarUrl"  :key="index">
                        <img src="@/assets/img/empty.png"  v-else :key="index">
                      </template>
                      <p>共{{item.likeCount}}人点赞推荐</p>
                    </div>
                  </div>
                  
                </div>
                
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <inquiry ref="inquiry"></inquiry>
  </div>
</template>

<script>
import gql from "graphql-tag";
import inquiry from "@components/inquiry";      //索取样品
import { mapGetters, mapActions } from "vuex";
import swiperCard from "@/pages/exhibition/component/swiper-card";
export default {
  name: "near-ex",
  data() {
    return {
      list: [],
      queryExhibitor:{},
      addr:'',
      region:'',
    };
  },
  components:{
    inquiry,
    swiperCard
  },
  computed:{
    ...mapGetters({
      userInfo: "getUserInfo",
      exonId:"getExhibitionId",
      exhibitionInfo:"getExhibitionInfo",
      configLogoIsSquare:'getConfigLogoIsSquare'
    }),
    exhibitionId() {
      return this.$route.query.exhibitionId||this.exonId;
    },
  },
  created() {
    // console.log(this.configLogoIsSquare);
    // this.getData();
    // console.log(this.userInfo,'userInfo');
  },
  methods:{
    ...mapActions({
      LinkExInvitation:'linkTo/LinkExInvitation',
      LinkProduct:'linkTo/LinkProduct',
      LinkExhibition:'linkTo/LinkExhibition',
      getRegionsByProvince:'getRegionsByProvince',
      LinkAct:"linkTo/LinkAct"
    }),
    isBottom(item){
      let bool=(item.activities&&item.activities.length)||(item.businesses&&item.businesses.length);
      // console.log(bool,'bool')
      return bool>0?true:false
    },
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    init(){
      if(this.userInfo.province){
        this.addr=this.userInfo.province+(this.userInfo.city&&this.userInfo.city!=this.userInfo.province?'·'+this.userInfo.city:'');
      }
      // console.log(this.userInfo,this.addr,'userInfo');
      if(this.addr){
        this.getData();
      }
    },
    async getData(){
      const query = gql`
        query queryExhibitor($query:QueryExhibitorInput!) {
          queryExhibitor(query:$query) {
            items{
              activities(num:3){
                id
                title
              }
              banner
              boothArea
              boothInfo
              businesses(num:3){
                id
                remark
                isSample
              }
              category
              company{
                id
                logo
                name
                category
                region
                address
              }
              compId
              exhibitionId
              followCount
              id
              isPopularize
              isLiving
              likeCount
              lookCount
              proCount
              activityCount
              liveCount
              continuouNumber
              likes{
                userInfo
              }
              newestEvaluates{
                id
                content
              }
              products(num:10){
                id
                exhibitorId
                banner
                view3DUrl
              }
              shareCount
              talkCount
              thinkCount
              userCount
              viewCount
            }
          }
        }
      `;
      let province=this.userInfo.province.replace(/省/g, "");
      province=province.replace(/市/g,"");
      let regions='';
      if(province.indexOf('特别行政区')!=-1){
        regions=province.replace(/特别行政区/g,"");
      }else{
        regions=await this.getRegionsByProvince(province);
      }
      this.region=regions;
      let opt={
        exhibitionId: this.exhibitionId,
        regions:regions,
        page:1,
        size:2,
      }
      this.$apollo.addSmartQuery("queryExhibitor", {
        query: query,
        variables: {
          query:opt
        },
        fetchPolicy: 'no-cache',    //清理缓存
        result(res) {
          let data = JSON.parse(JSON.stringify(res.data.queryExhibitor));
          // let data=res.data.giveExInfo;
          console.log('请求回来了near-ex',data)
          if (data&&data.items.length) {
              data.items.forEach(e=> {
                if(e.category&&e.category.indexOf('[') !== -1){
                  e.category = JSON.parse(e.category)[0].Value
                }
                // console.log(e);
                // if(e.category&&e.category.indexOf('[')!=-1){
                //   let cateArr=JSON.parse(e.category) 
                //   e.category=this.getCate(cateArr);
                // }
                // if(e.products.length){
                //   e.products.forEach(c=>{
                //     if(c.banner&&c.banner.indexOf('[')!=-1){
                //       let arr=JSON.parse(c.banner);
                //       c.banner=arr[0];
                //     }else{
                //       c.banner='';
                //     }
                //   })
                // }
              });
              this.list=data.items;
              // console.log('附近展商完成')
              // console.log(this.list,'list')
          }
          
        },
        error(err) {},
      });
    },
    getCate(arr){
      let str='';
      for (let i = 0; i < arr.length; i++) {
        str+=str?','+arr[i].Value:arr[i].Value
      }
      return str
    },
    more(){
      this.LinkExhibition({id:this.exhibitionId,region:this.region});
    },
    //索取样品点击
    inquiryClick(item){
      if(!item.businesses[0].isSample){
        return
      }
      
      // return
      // console.log(exInfo);
      this.$store.commit('company/setExhibitorId',item.id);
      this.$store.commit('company/setCompanyId',item.compId);
      let exInfo={
        compLogo:item.company.logo,
        compName:item.company.name,
        boothInfo:item.boothInfo
      }
      this.$refs.inquiry.open(exInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.ne {
  background-color: #fff;
  margin-bottom: 15px;
  &-title {
    padding: 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    .txt1 {
      font-size: 0.3rem;
      color: #333;
      display: flex;
      align-items: baseline;
      font-weight: bold;
      flex: 1;
    }
    .txt2 {
      font-size:0.26rem;
      color: #999;
      margin-left: 10px;
    }
    .txt3 {
      margin-left: 10px;
      font-size: 0.24rem;
      color: #666;
    }
  }
  &-content {
  }
}

 .zs {
    width: 100%;
    box-sizing: border-box;
    padding:.3rem .3rem;
    border-top: 1px solid #f4f4f4;
    &:first-child{
      border-top: none;
    }
    &-item {
      display: flex;
      flex: 1;
      // align-items: center;
      .zs-number{
        color: #333;
        font-weight: bold;
        font-size: .28rem;
        flex-shrink: 0;
      }
      .zs-logo {
        // margin-left: .3rem;
        position: relative;
        box-sizing: border-box;
        flex-shrink: 0;
        img {
          width: 1.2rem;
          height: 1.2rem;
          display: block;
          box-sizing: border-box;
          border-radius: 50%;
          border: 1px solid #eaeaea;
          &.empty-img {
            opacity: 1;
            width: 100%;
            height: auto;
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
      .zs-test {
        padding-left: .15rem;
        // height: 1.4rem;
        // justify-content: space-between;
        width: calc(100% - 1.2rem);
        &-booth {
          max-width: 95%;
          display: flex;
          align-items: center;
          overflow: hidden;
          height: .4rem;
          font-size: .2rem;
          color: #666;
          margin-top: .08rem;
          margin-left: -0.09rem;
          .zs-addr {
            font-size: .2rem;
            flex-shrink: 0;
            margin-right: .2rem;
          }
          .zs-tag {
            box-sizing: border-box;
            border-radius: .05rem;
            display: flex;
            align-items: center;
            color: #333;
            .iconfont{
              color:#1890ff;
              font-size: .42rem;
              transform: translateY(.03rem);
            }
            .icon-biaoqian1{
              position: relative;
              top: -.02rem;
            }
            .icon-dizhi{
              color: #fe781d;
              position: relative;
              top:-.04rem;
              font-size: .38rem;
            }
            p {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .zs-booth{
            margin-right: .15rem;
          }
          .zs-type{
             overflow: hidden;
          }
        }
        .item-padd {
          margin: 6px 0 5px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #999;
          flex-wrap: wrap;
          .brand {
            line-height: 1.2;
            margin-right: 8px;
            span {
              color: #999;
              line-height: 18px;
              display: inline-block;
              display: flex;
              align-items: center;
              .icon-zhiboguankanshu {
                position: relative;
                top: -1px;
              }
              .icon-dianzan {
                position: relative;
                top: -2px;
              }
            }
            .iconfont {
              font-size: 18px;
              display: inline-block;
              margin-right: 2px;
              color: #999;
            }
          }
        }
        &-title {
          max-width: 95%;
          display: flex;
          align-items: center;
          p {
            color: #333;
            font-weight: 600;
            font-size: .3rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .is_live{
            width: 0.88rem;
            height: 0.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            color: #fff;
            margin-left: .15rem;
            background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
              linear-gradient(#000, #000);
            background-blend-mode: normal, normal;
            border-radius:0.05rem;
            color: #fff;
            font-size: 0.18rem;
            // vertical-align: middle;
            span{
              display: block;
              height: .12rem;
              width: .12rem;
              margin-right: .06rem;
              border-radius: 50%;
              background: #fff;
            }
          }
          .is_hot{
            background: #ff5c00;
          }
          .hot_tag{
            width: .68rem;
            height: .24rem;
            display: flex;
            justify-content: center;
            align-items: center;  
            color: #fff;
            flex-shrink: 0;
            background-color: #ff5c00;
	          border-radius: .05rem;
            font-size: .14rem;
            margin-left: .1rem;            
            .iconfont {
              margin-left: -.06rem;
              font-size: .28rem;
              // transform: scale(1.3);
            }
          }
          
        }
        .english_name{
          max-width: 95%;
          font-size: .24rem;
          font-weight: bold;
          line-height: .32rem;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &-icon {
          display: flex;
          font-size:.2rem;
          position: relative;
          .jyb_text{
            position: absolute;
            left: 0;
            bottom: -.35rem;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color:#999;
            font-size: .2rem;
            span{
              color: #ff5c00; 
            }
          }
          .icon_jyb{
            width:.84rem;
            height: .3rem;
            border-radius: .04rem;
            margin-top: .15rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(248,90,16,0.1);
            img{
              width: .54rem;
              height: .23rem;
              display: block;
            }
          }
          .icon_tag{
            margin-top: .1rem;
            height: .3rem;
            padding: 0 .08rem 0 .05rem;
            color: #fff;
            border-radius: .04rem;
            display: flex;
            align-items: center;
            margin-right: .1rem;
            &:last-child{
              margin-right: 0;  
            }
            &.rz{
              background-color: #ffb528;
            }
            &.qy{
              background-color: #108ee9;
            }
            .iconfont{
              transform: translateY(1px);
            }
            
          }
        }
        &-rank{
          margin-top: .14rem;
          .type{
            display: flex;
            width: 1.85rem;
            height: .42rem;
            background-color: rgba(255, 94, 0,.15);
            border: solid 1px #ffe7d9;
            .img{
              width: .42rem;
              height: 100%;
              background: #fff;
              img{
                width: .3rem;
                height: .3rem;
                display: block;
                margin:.06rem 0 0 .06rem;
              }
            }
            span{
              font-size: .22rem;
              line-height: .42rem;
              color: #ff5e00;
              display: inline-block;
              text-align: center;
              flex: 1;
            }
          }
        }
        &-count{
          margin-top: .08rem;
          p{
            font-size: .24rem;
            font-weight: normal;
            line-height: .3rem;
            color: #333;
            i{
              font-style: normal;
              color: #fe781d;
              margin-right: .08rem;
            }
            span{
              margin: 0 .1rem;
            }
          }
        }
        .rc-row2 {
          margin-top: .04rem;
          color: #666;
          line-height: .2rem;
          font-size: .12rem;
          color: rgb(102, 102, 102);
          &_item {
            margin-bottom: .05rem;
            word-break: break-all;
          }
        }
      }
      &-blist {
        z-index: 2;
        position: relative;
        &_one {
          img {
            width: 100%;
          }
          p {
            font-size: .13rem;
            margin-top: .06rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      &-bact {
        z-index: 2;
        position: relative;
        .rc-row2_item {
          margin-bottom: .1rem;
          font-size: .12rem;
          color: #666;
          line-height: 1.5;
          &:only-child,
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      &-act {
        margin-top: 15px;
        .van-notice-bar{
          background: #fff;
          color: #666;
          padding:0;
          height: .46rem;
          .notice-swipe{
            height: .46rem;
            width: 100%;
          }
          .act-list{
            line-height: initial;
            p{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span{
              width: .48rem;
              height: .28rem;
              background-color: #f0eded;
              border-radius: .02rem;
              border: solid 1px #d27976;
              color: #e4514c;
              font-size: .18rem;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 2px;
              flex-shrink: 0;
              // line-height: .28rem;
            }
            .bus{
              background-color: #ffefe5;
              border: solid 1px #ff5d00;
              color: #ff5e00;
            }
            &-p{
              display: flex;
              align-items: center;
              height: 0.28rem;
              p{
                // max-width: 75%;
                margin-left:0.08rem;
              }
              &.hd{
                p{
                  // max-width: calc(100% - 0.6rem);
                }
              }
              .no-span{
                max-width: 95%;
              }
              .remark{
                margin-left: 0.08rem;
                font-size: .22rem;
                border:none;
                border-bottom: 1px solid #199bff;
                color: #199bff;
                padding: 0;
                background: transparent;
                width:auto;
                height: 0.28rem;
              }
            }
          }
        }
      }
    }
    .zs-row {
      &.s-left {
        padding-left: 0;
      }
      &-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }
      .zs-img-box {
        position: relative;
        width: .6rem;
        height: .6rem;
        box-sizing: border-box;
        margin-left: .04rem;
        display: inline-block;
        flex-shrink: 0;
        img {
          width: .6rem;
          height: .6rem;
          display: inline-block;
          border-radius: 50%;
          border: 1px solid #eaeaea;
          &.empty-img {
            opacity: 1;
            width: 100%;
            height: auto;
            position: absolute;
            margin: auto;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
    // .zs-item-center {
    //     display: flex;
    //     align-items: center;
    //   .zs-item-bottom-left{
    //     width: 1.4rem;
    //   }
      // .zs-item-bottom{
      //   padding-left: 0.15rem;
      //   width: calc(100% - 1.4rem);
      // }
      .zs-item-blist {
        font-size: 0;
        display: flex;
        position: relative;
        padding: .18rem .24rem;
        background: #fff;
        box-shadow: 0 0 .1rem 0 rgba(0, 0, 0, 0.2);
        border-radius: .06rem;
        &_one {
          width: 31%;
          //  margin-right:20px;
        }
        &_one:nth-child(2n + 2) {
          margin: 0 3.5%;
        }
        &_imgbox {
          width: 100%;
          position: relative;
          height: 0;
          overflow: hidden;
          padding-bottom: 100%;
          .d_tag{
            position: absolute;
            z-index: 1;
            width: .6rem;
            height: .26rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ff5c00;
            box-sizing: border-box;
            border-radius:0 0 0 5px;
            color: #fff;
            font-size: .16rem;
            right: 0;
            top: 0;
            .iconfont{
              font-size: .28rem;
            }
          }
          img {
            position: absolute;
            width: 100%;
            height: 100%;
            // object-fit: cover;
            top: 0;
            left: 0;
          }
        }
      }
      .zs-item-news{
        width: 100%;
        margin-top: .2rem;
        background-color: #f7f7f7;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #666;
        padding:4px 8px;
        span{
          color: #999;;
        }
      }
      .zs-item-zan{
        min-width: 100px;
        height: 22px;
        display: flex;
        margin-top: .2rem;
        img{
          width: 22px;
          height: 22px;
          border-radius: 50%;
          display: block;
          border: 1px solid #fff;
        }
        img:nth-child(1){
          z-index: 13;
          position: relative;
        }
        img:nth-child(2){
          z-index: 12;
          position: relative;
          margin-left: -10px;
        }
        img:nth-child(3){
          z-index: 11;
          position: relative;
          margin-left: -10px;
        }
        p{
          min-width: 48px;
          height: 23px;
          color: #999;
          font-size: 0.22rem;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 18px;
          margin-left: -10px;
          text-align: center;
          padding-right: 5px;
        }
      }
    // }
    
  }
</style>